import { makeStyles } from "tss-react/mui"
import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { OrderLine } from "../ordersForCalendarTypes"

const useStyles = makeStyles()((theme) => ({
    tableHeadTextColor: {
        color: theme.palette.tailwind.slate[500],
    },
    textColor: {
        color: theme.palette.tailwind.slate[900],
    },
    textCenter: {
        textAlign: "center",
    },
    textRight: {
        textAlign: "right",
    },
}))

type ProductionSlipDialogTableProps = {
    orderLines: OrderLine[]
}

export const ProductionSlipDialogTable = ({ orderLines }: ProductionSlipDialogTableProps) => {
    const { classes, cx } = useStyles()

    return (
        <Box>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell className={cx(classes.tableHeadTextColor, classes.textRight)}>
                            <LocalizedStrict id="production-slip-dialog-table-header-items">
                                <>Items</>
                            </LocalizedStrict>
                        </TableCell>
                        <TableCell className={classes.tableHeadTextColor}>
                            <LocalizedStrict id="production-slip-dialog-table-header-products">
                                <>Products</>
                            </LocalizedStrict>
                        </TableCell>
                        <TableCell className={cx(classes.tableHeadTextColor, classes.textCenter)}>
                            <LocalizedStrict id="production-slip-dialog-table-header-delivery-time">
                                <>Delivery time</>
                            </LocalizedStrict>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {orderLines &&
                        orderLines.map((order, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableCell>
                                        <Typography
                                            variant="body1"
                                            className={cx(classes.textColor, classes.textRight)}
                                        >
                                            {order?.items ?? "0"}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body1" className={classes.textColor}>
                                            {order?.name ?? "-"}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography
                                            variant="body1"
                                            className={cx(classes.textColor, classes.textCenter)}
                                        >
                                            {order?.deliveryTime ?? "-"}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                </TableBody>
            </Table>
        </Box>
    )
}
